<template>
    <!--
    <component v-if="!loading" :is="layout"></component>
    <div v-else class="loading-screen" :class="className">
        <i class="mdi mdi-spin mdi-loading mdi-48px"></i>
    </div>
-->
    <router-view></router-view>        
    
</template>
<script>
export default {
    computed: {
        empresa() {
            return this.$store.state.empresa;
        },
        className() {
            return this.empresa.className;
        },

        layout() {
            return (this.$route.meta.layout || 'Default') + 'Layout';
        },
        loading() {
            return this.$store.state.loading;
        }
    },
    
}
</script>
<style lang="less">
    @import '/css/colors.less';
    :root {
        color-scheme: only light;
    }
    html, body {
        margin: 0;
        padding: 0;
        width: 100%;
        height: 100%;
        font-family: sans-serif;
        font-size: 16px;
        overflow: hidden;
    }
    *, *::before, *::after {
        box-sizing: border-box;
    }
    .loading-screen {
        display: flex;
        width: 100%;
        height: 100%;
        color: white;
        background-color: var(--primary);
        justify-content: center;
        align-items: center;
    }
    .swal2-container {
        z-index: 9999999999!important;
    }
</style>